import { RestRequest, } from '@Utils';
import {
  IPreviewVoiceInternalCall,
  ICreateInternalVoiceCallRequest,
  ICreateInternalVoiceCallResponse,
} from 'atlas-shared/dist';

export * from './abstract/voice_internal_call.api.abstract';

export const hangupVoiceInternalCall = async (id: IPreviewVoiceInternalCall['id']): Promise<IPreviewVoiceInternalCall> => {
  return RestRequest.delete<IPreviewVoiceInternalCall>(`voice_internal_call/${id}`);
};

export const hangupRequestVoiceInternalCall = async (id: IPreviewVoiceInternalCall['id']): Promise<IPreviewVoiceInternalCall> => {
  return RestRequest.delete<IPreviewVoiceInternalCall>(`voice_internal_call/${id}/terminate`);
};

export const createVoiceInternalCall = (body: ICreateInternalVoiceCallRequest): Promise<ICreateInternalVoiceCallResponse> => {
  return RestRequest.post<ICreateInternalVoiceCallRequest, ICreateInternalVoiceCallResponse>('voice_internal_call', body);
};
